<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" v-if="showAction(1)"/>
      <v-card v-if="showAction(1)">
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <branch-offices-list
              :classOfDiv="cols"
              style="padding-top: 22px"
              v-on:triggerChange="branchOfficeSelected"
              :model="idBranchOfficeSelected"
            />
            
            <v-col>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" xl="3" sm="12">
              <v-tooltip
                top
                v-if="$utilFront.withPermission($prm.STOCK_ADD)"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="changeAction(2)"
                    color="primary"
                    block
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left> mdi-view-grid-plus </v-icon>
                    Nuevo medicamento
                  </v-btn>
                </template>
                <span>Agregar medicamentos</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="list"
            :search="search"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-text': 'Elementos por página',
              'items-per-page-all-text': 'Todo',
            }"
            no-results-text="Sin resultados coincidentes con la búsqueda"
            loading-text="Cargando..."
            no-data-text="Sin resultados disponibles"
            dense
            fixed-header
            height="auto"
          >
            <template v-slot:[`item.product.text`]="{ item }">
              <small>{{ item.product.text }}</small>
            </template>
            <template v-slot:[`item.comment`]="{ item }">
              <small>{{ item.comment || "ND" }}</small>
            </template>

            <template v-slot:[`item.actions`]="{ item, index }">
              <v-tooltip top v-if="$utilFront.withPermission($prm.STOCK_MINUS)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="openDialogMinus(item, index)">
                    <v-icon color="error" v-bind="attrs" v-on="on">
                      mdi-package-variant
                    </v-icon>
                  </v-btn>
                </template>
                <span>Dar de baja</span>
              </v-tooltip>
              <span v-else>- - - </span>
              <!-- <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon @click="checkHistory(item)">
                    <v-icon color="primary" v-bind="attrs" v-on="on">
                      mdi-history
                    </v-icon>
                  </v-btn>
                </template>
                <span>Visualizar historial del Stock</span>
              </v-tooltip> -->
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-text>
          <v-row align="baseline" justify="center" class="pb-4">
            <v-col class="text-center">
            
                  <v-btn
                    @click="dialog = true"
                    outlined
                    small
                    color="error"
                  >
                    <v-icon left> mdi-file-pdf-box </v-icon> Reporte Entradas
                  </v-btn>
            </v-col>
            <v-col class="text-center">
           
                  <v-btn
                    @click="downloadStock()"
                    outlined
                    small
                    color="error"
                  >
                    <v-icon left> mdi-file-pdf-box </v-icon> Reporte de existencias
                  </v-btn>
               
            </v-col>
            <v-col>
              <v-btn
                outlined
                small
                color="green darken-1"
                :disabled="sending"
                @click="downloadReportXLSX()"
                >Exportar excel
                <v-icon right>mdi-microsoft-excel</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <encabezado :elementos="encabezado" v-if="showAction(2) || showAction(3)"/>
      <v-card v-if="showAction(2) || showAction(3)">
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-card-text>
            <v-container>
              <v-form @submit.prevent="doAction">
                <v-row align="center" justify="center">
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Producto"
                      rules="required"
                    >
                      <v-autocomplete
                        v-model="model.product"
                        :items="products"
                        :error-messages="errors"
                        label="Producto"
                        no-data-text="Sin resultados disponibles"
                        clearable
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Cantidad"
                      rules="min_value:1|numeric|required"
                    >
                      <v-text-field
                        v-model="model.quantity"
                        :error-messages="errors"
                        label="Cantidad"
                        type="number"
                        required
                        min="1"
                        autocomplete="off"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Lote"
                      rules="required|max:100"
                    >
                      <v-text-field
                        v-model="model.lot"
                        :counter="100"
                        :maxlength="100"
                        :error-messages="errors"
                        label="Lote"
                        required
                        autocomplete="off"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Caducidad"
                      rules="required"
                    >
                      <v-text-field
                        v-model="model.expiration"
                        :counter="100"
                        :maxlength="100"
                        :error-messages="errors"
                        label="Caducidad"
                        required
                        autocomplete="off"
                        type="date"
                      ></v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Comentario"
                      rules="max:255"
                    >
                      <v-textarea
                        rows="1"
                        auto-grow
                        v-model="model.comment"
                        :counter="255"
                        :maxlength="255"
                        name="Comentario"
                        :error-messages="errors"
                        dense
                        clearable
                        label="Fuente de financiamiento (opcional)"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col class="text-center mt-5">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          type="button"
                          fab
                          color="secondary"
                          :disabled="invalid || sending"
                          @click="addList()"
                        >
                          <v-icon color="white" v-bind="attrs" v-on="on">
                            mdi-plus
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        {{
                          invalid || sending
                            ? "Complete los campos"
                            : "Agregar a la entrada"
                        }}</span
                      >
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-form>

              <v-row>
                <v-col>
                  <h3 class="font-weight-black mb-5">Productos</h3>
                </v-col>
              </v-row>

              <v-row align="center" justify="center" class="pb-4">
                <v-col>
                  <v-text-field
                    v-model="searchStock"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headersStock"
                :items="stocks"
                :search="searchStock"
                :items-per-page="10"
                :footer-props="{
                  'items-per-page-text': 'Elementos por página',
                  'items-per-page-all-text': 'Todo',
                }"
                no-results-text="Sin resultados coincidentes con la búsqueda"
                loading-text="Cargando..."
                no-data-text="Sin resultados disponibles"
                dense
                fixed-header
                height="auto"
              >
                <template v-slot:[`item.expiration`]="{ item }">
                  {{ $utilFront.formatDate(item.expiration) }}
                </template>
                <template v-slot:[`item.comment`]="{ item }">
                  {{ item.comment ? item.comment : "ND" }}
                </template>
                <template v-slot:[`item.actions`]="{ index }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon @click="stocks.splice(index, 1)">
                        <v-icon color="error" v-bind="attrs" v-on="on">
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Remover</span>
                  </v-tooltip>
                </template>
              </v-data-table>

              <v-row>
                <v-col>
                  <h3 class="font-weight-black mb-5">Proveedor</h3>
                </v-col>
              </v-row>

              <v-row align="center" justify="center">
                <v-col cols="12" md="6" xl="4" sm="12">
                  <v-text-field
                    v-model="supplier"
                    :counter="255"
                    :maxlength="255"
                    label="Nombre de proveedor"
                    required
                    autocomplete="off"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-row
              align="center"
              justify="center"
              class="d-flex flex-row-reverse text-center py-4"
            >
              <v-col>
                <v-btn
                  type="buttom"
                  @click="add()"
                  :disabled="
                    $utilFront.isEmptyList(stocks) ||
                    $utilFront.isEmpty(supplier) ||
                    sending
                  "
                  color="primary"
                >
                  <v-icon left>mdi-content-save</v-icon> Guardar
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  type="button"
                  color="error"
                  plain
                  @click="changeAction(1)"
                  :disabled="sending"
                  class="mr-5"
                >
                  <v-icon left>mdi-close</v-icon> Cancelar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </validation-observer>
      </v-card>

      <v-dialog v-model="dialogMinus" persistent max-width="600">
        <v-card>
          <v-card-title>
            <h5 class="font-weight-bold">
              Baja de almacén:
              <span class="error--text">{{ stock.idStock }}</span>
            </h5>
          </v-card-title>

          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Cantidad"
                      :rules="`required`"
                    >
                      <v-slider
                        v-model="stock.quantity"
                        :error-messages="errors"
                        label="Cantidad"
                        persistent-hint
                        thumb-label="always"
                        :max="stock.initialQuantity"
                        :min="1"
                        @change="calculeQuantity"
                      ></v-slider>
                    </validation-provider>

                    <!-- <v-text-field
                    label="Cantidad"
                    type="number"
                    min="1"
                    v-model.number="stock.quantity"
                    :max="stock.initialQuantity"
                    @input="calculeQuantity"
                  /> -->
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <validation-provider
                      v-slot="{ errors }"
                      rules="required|max:255"
                      name="Motivo"
                    >
                      <v-textarea
                        label="Motivo"
                        outlined
                        v-model="stock.comment"
                        :error-messages="errors"
                        auto-grow
                        :counter="255"
                      >
                      </v-textarea>
                    </validation-provider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <h3>
                      Cantidad restante:
                      <span class="error--text">{{
                        stock.currentQuantity
                      }}</span>
                    </h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions class="text-center">
              <v-col>
                <v-btn
                  type="button"
                  color="error"
                  plain
                  @click="dialogMinus = false; $refs.observer.reset()"
                  :disabled="sending"
                >
                  Cancelar<v-icon right>mdi-close</v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  type="buttom"
                  @click="addMinus()"
                  :disabled="
                    sending || invalid || $utilFront.isEmpty(stock.comment)
                  "
                  color="primary"
                >
                  Guardar<v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" width="600">
        <v-card>
          <v-card-text>
            <div class="col-md-12 text-center">
              <DateByRangeComponent
                ref="DateByRangeComponent"
                :typeCalendar="3"
                v-on:dateChange="dateChange"
              />
            </div>
            <v-row>
              <v-col class="text-center">
                <v-btn @click="dialog = false" color="error" plain>
                  <v-icon left> mdi-chevron-left </v-icon> volver
                </v-btn>
              </v-col>
              <v-col class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="downloadWarehouseEntry()"
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="dateSelected.startDate == ''"
                    >
                      <v-icon left> mdi-file-pdf-box </v-icon> Descargar Reporte
                    </v-btn>
                  </template>
                  <span>Descargar reporte de Salida</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog
      v-model="dialogHistory"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="clearHistory()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title id="inicio"
            >Historial de movimientos del Stock:
            <b>{{ dataHistory.idStock }}</b></v-toolbar-title
          >
          <v-spacer></v-spacer>
          <!-- <v-toolbar-items>
            <v-btn dark text @click="dialogHistory = false"> Save </v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <v-list three-line subheader>
          <v-subheader>Información del Stock</v-subheader>
          <v-row
            style="display: flex; justify-content: center; align-items: center"
          >
            <v-col>
              <v-list-item>
                <v-list-item-content>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <v-icon>mdi-file-document</v-icon>
                  </div>
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    Información del Stock
                  </div>
                  <br />
                  <div
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <div>
                      <v-list-item-subtitle
                        >Fecha de registro:
                        <b>{{
                          dataHistory.registrationDate
                        }}</b></v-list-item-subtitle
                      >
                      <v-list-item-subtitle
                        >Producto:
                        <b>{{ dataHistory.p }}</b></v-list-item-subtitle
                      >
                      <v-list-item-subtitle
                        >Existencia:
                        <b>{{ dataHistory.quantity }}</b></v-list-item-subtitle
                      >
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <!-- <v-card-text>{{ dataHistory }}</v-card-text> -->
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader>
          <v-subheader>Historial de Stock</v-subheader>
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <div style="width: 95%">
              <v-row align="baseline" justify="center" class="pb-4">
                <v-col>
                  <v-text-field
                    v-model="searchHistory"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <br />
              <v-data-table
                :headers="headersHistory"
                :items="listHistory"
                :search="searchHistory"
                no-results-text="Sin resultados coincidentes con la búsqueda"
                loading-text="Cargando..."
                no-data-text="Sin resultados disponibles"
                dense
                hide-default-footer
                disable-pagination
                fixed-header
                height="auto"
              >
                <template v-slot:[`item.typeHistoryDesc`]="{ item }">
                  <v-chip
                    :color="item.color"
                    style="width: 200px; justify-content: center"
                  >
                    {{ item.typeHistoryDesc }}
                  </v-chip>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "@/components/Sidebar";
import AutoLogout from "@/components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { UtilFront } from "@/core/";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, max } from "vee-validate/dist/rules";
import BranchOfficesList from "../../components/BranchOfficesList.vue";
import DateByRangeComponent from "@/components/Calendars.vue";

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});
extend("max", {
  ...max,
  message: "{_field_} no debe tener más de {length} caracteres",
});

import {
  StockRequest,
  ProductsRequest,
  ReportPDFRequest,
} from "@/core/request";

export default {
  name: "Almacen",
  components: {
    Loader,
    Sidebar,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    AutoLogout,
    BranchOfficesList,
    DateByRangeComponent,
  },
  data() {
    return {
      sending: false,
      dialog: false,
      menu: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      service: StockRequest,
      search: "",
      headers: [
        { text: "ID Stock", value: "idStock", width: "5%" , align: "center"},
        { text: "Clave", value: "product.product_key" , align: "center"},
        { text: "Nombre del producto", value: "product.name" },
        { text: "Descripción", value: "product.text", width: "35%", align: "center" },
        { text: "Existencia", value: "quantity" },
        { text: "Caducidad", value: "expirationDateText", align: "center" },
        { text: "Lote", value: "lot" , align: "center"},
        { text: "Fuente de financiamiento", value: "comment" , align: "center"},
        { text: "Acciones", value: "actions", sortable: false , align: "center"},
      ],
      encabezado: {
        icono: "mdi-cube",
        texto: "Almacén | Farmacia",
      },
      headersStock: [
        { text: "Clave", value: "product.product_key", width: "10%" },
        { text: "Producto", value: "product.fullName", width: "40%" },
        { text: "Cantidad", value: "quantity" },
        { text: "Lote", value: "lot" },
        { text: "Caducidad", value: "expiration" },
        { text: "Fuente de financiamiento", value: "comment" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
      searchStock: "",
      products: [],
      status: ["Bueno", "Regular", "Malo"],
      stocks: [],
      supplier: "",
      stock: {},
      dialogMinus: false,
      invalidDialog: false,
      dialogHistory: false,
      dataHistory: {},
      listHistory: [],
      searchHistory: "",
      headersHistory: [
        { text: "ID Historial", value: "idStockHistory" },
        { text: "Fecha de registro", value: "registrationDateHistory" },
        { text: "Destino", value: "locationKey" },
        { text: "Descripción", value: "typeHistoryDesc" },
        { text: "Responsable", value: "nameHumanResource" },
      ],
      idBranchOfficeSelected: null,
      dialog: false,
      dateSelected: { startDate: "", endDate: "" },
      cols: "col-md-3 col-xl-3 col-sm-12",
    };
  },
  mounted() {
    this.listAll();
    this.listProducts();
  },
  methods: {
        downloadReportXLSX() {
     this.sending = true;

      ReportPDFRequest.exportWarehouse({
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
            })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel",
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Reporte_de_almacen.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    catchError: (e, x) => {
      UtilFront.errorhttp(e);
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.$refs.observer.reset();
        this.model = {};
        this.stocks = [];
        this.supplier = "";
        this.action = action;
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    listAll() {
      this.sending = true;
      let params = {
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        statusStock: [1],
      };
      this.service
        .listAllByBranchOffice(params)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.list = data;
          } else {
            this.list = [];
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
        });
    },
    add() {
      if(!this.sending){
      let data = {
        supplier: this.supplier,
        idHumanResource: this.$utilFront.getIdHumanResource(),
        stocks: this.stocks,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      this.sending = true;
      this.service
        .addEntry(data)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.$utilFront.notifications(
              "Se ha registrado correctamente.",
              "SUCCESS"
            );
            this.listAll();
            this.changeAction(1);
          } else {
            message = message || "Ocurrió un error durante el registro.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
          this.downloadWarehouseEntry(moment(new Date()).format("YYYY-MM-DD"));
        });
      }
    },
    listProducts() {
      this.products = [];
      ProductsRequest.listAllProducts()
        .then((res) => {
          let { data, response, message } = res.data;
          if (this.$utilFront.nonEmptyList(data)) {
            this.products = data.map((it) => {
              let product = {
                idProduct: it.idProduct,
                fullName: it.name + " " + it.text,
                product_key: it.product_key,
              };
              return {
                text: `${it.product_key} | ${it.name} | ${it.text}`,
                value: product,
              };
            });
          }
        })
        .catch(this.catchError)
        .finally(() => {});
    },
    addList() {
      let stock = Object.assign(this.model, {});
      stock.expiration = moment(stock.expiration).endOf("day").toDate();
      this.stocks.unshift(stock);
      this.model = {};
      this.$refs.observer.reset();
    },
    openDialogMinus(item, index) {
      this.stock = Object.assign(item, {});
      this.stock = {
        quantity: this.stock.quantity,
        comment: "",
        idStock: this.stock.idStock,
        currentQuantity: Number(0),
        initialQuantity: Number(this.stock.quantity),
      };
      this.dialogMinus = true;
    },
    calculeQuantity() {
      this.invalidDialog = false;
      this.stock.currentQuantity =
        this.stock.initialQuantity - this.stock.quantity;

      // if (
      //   this.stock.currentQuantity < 0 ||
      //   this.stock.currentQuantity > this.stock.initialQuantity ||
      //   this.stock.quantity <= 0
      // ) {
      //   this.stock.currentQuantity = 0;
      //   this.stock.quantity = Number(this.stock.initialQuantity);
      //   this.$utilFront.notifications(
      //     "Valor fuera del rango 1 a " + this.stock.initialQuantity + "",
      //     "ERROR"
      //   );
      //   this.invalidDialog = true;
      // }
    },
    addMinus() {
      let stocksOutput = [
        {
          idStock: this.stock.idStock,
          quantity: this.stock.quantity,
          comment: this.stock.comment,
        },
      ];

      let params = {
        type: 1, //Merma
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        idHumanResource: this.$utilFront.getIdHumanResource(),
        stocks: stocksOutput,
        comment: this.stock.comment,
      };

      this.sending = true;
      this.service
        .addOutput(params)
        .then((res) => {
          let { data, response, message } = res.data;
          if (response) {
            this.$utilFront.notifications(
              "Se ha registrado correctamente.",
              "SUCCESS"
            );
            this.dialogMinus = false;
            this.listAll();
          } else {
            message = message || "Ocurrió un error durante el registro.";
            this.$utilFront.notifications(message, "ERROR");
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.sending = false;
          this.$refs.observer.reset();
        });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAll();
    },
    dateChange(dates) {
      this.dateSelected = dates;
    },
    downloadWarehouseEntry(date) {
      this.sending = true;
      const fileName = `Orden_de_salida_${moment(
        new Date(this.dateSelected.startDate)
      ).format("YYYY-MM-DD")} - ${moment(
        new Date(this.dateSelected.endDate)
      ).format("YYYY-MM-DD")}`;
      if (date != null) {
        this.dateSelected.startDate = date;
        this.dateSelected.endDate = date;
      }
      const data = {
        fileName: fileName,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        startDate: this.dateSelected.startDate,
        endDate: this.dateSelected.endDate,
      };
      ReportPDFRequest.downloadWarehouseEntry(data)
        .then((res) => {
          if (res.status == 200 && res.data.type != "application/json") {
            this.$utilFront.openPDF(res.data);
          } else {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .finally(() => {
          this.$refs.DateByRangeComponent.modalDateRangeClean();
          this.sending = false;
        });
      this.dialog = false;
    },
    downloadStock() {
      this.sending = true;
      const fileName = `Stock_${moment(new Date()).format(
        "YYYY-MM-DD"
      )} - ${moment(new Date()).format("YYYY-MM-DD")}`;
      const data = {
        fileName: fileName,
        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
        startDate: moment(new Date()).format("YYYY-MM-DD"),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
      };
      ReportPDFRequest.downloadStock(data)
        .then((res) => {
          if (res.status == 200 && res.data.type != "application/json") {
            this.$utilFront.openPDF(res.data);
          } else {
            this.$utilFront.displayErrorPdf(res.data);
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    checkHistory(item) {
      this.loader = true;
      this.dataHistory = item;
      let postData = {
        idStock: item.idStock,
      };

      this.service
        .stockHistory(postData)
        .then((res) => {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.listHistory = res.data.data.map((obj) => {
              let typeHistoryDesc;
              let color;
              switch (obj.typeHistory) {
                case 1:
                  typeHistoryDesc = "Entrada de Producto";
                  color = "primary";
                  break;
                case 2:
                  typeHistoryDesc = "Baja de Producto";
                  color = "warning";
                  break;
                case 3:
                  typeHistoryDesc = "Dispensación de Producto";
                  color = "info";
                  break;
              }
              return {
                idStockHistory: obj.idStockHistory,
                humanResource: obj.humanResource,
                nameHumanResource: obj.humanResource.person.fullName,
                registrationDateHistory: moment(obj.registrationDate).format(
                  UtilFront.FORMAT_DATE_TIME
                ),
                locationKey: obj.locationKey,
                typeHistoryDesc: typeHistoryDesc,
                type: obj.typeHistory,
                color: color,
              };
            });
          } else if (code == 401) {
            this.unauthorized();
          }
        })
        .catch(this.catchError)
        .finally(() => {
          this.dataHistory.registrationDate =
            typeof item.registrationDate === "number"
              ? moment(item.registrationDate).format(UtilFront.FORMAT_DATE_TIME)
              : item.registrationDate;
          this.dataHistory.p = this.dataHistory.product.name;
          this.loader = false;
          this.dialogHistory = true;
        });
    },
    clearHistory() {
      this.dialogHistory = false;
      this.dataHistory = {};
    },
  },
};
</script>
